import type { Permission } from '@/api/access/accessApi.types';

export interface PermissionResourceGroup {
  resource: string;
  permissions: Permission[];
}

export function groupPermissionsByResource(permissions: Permission[]): PermissionResourceGroup[] {
  const groups: PermissionResourceGroup[] = [];
  const groupIndexByResource = new Map<string, number>();

  permissions.forEach(function assignToGroup(permission) {
    const existingIndex = groupIndexByResource.get(permission.resource);
    if (existingIndex === undefined) {
      groupIndexByResource.set(permission.resource, groups.length);
      groups.push({ resource: permission.resource, permissions: [permission] });
      return;
    }
    const existingGroup = groups[existingIndex];
    if (existingGroup !== undefined) {
      existingGroup.permissions.push(permission);
    }
  });

  return groups;
}
